import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "dropDownItem",
        "selectedObjectsContainer",
        "formInput",
        "modal"
    ]
    static values = {
        placeholder: String,
        submitFormOnClose: Boolean,
        multiple: Boolean,
        toggleRequired: Boolean
    }

    connect() {
        const inputType = this.multipleValue ? "checkbox" : "radio";
        this.dropDownItemTargets.forEach((item) => {
            item.querySelectorAll(`input[type='${inputType}'], label`).forEach((element) => {
                // Ensure toggleSelection is always called, even when clicking directly on the input or label
                element.addEventListener('click', (e) => this.toggleSelection(e));
            });
        });

        this.updateSelectedObjects();
    }

    handleDropdownClose() {
        if (this.submitFormOnCloseValue) {
            this.formInputTarget.form.requestSubmit();
        }
    }

    toggleSelection(event) {
        const inputType = this.multipleValue ? "checkbox" : "radio";
        const item = event.currentTarget;
        const input = item.querySelector(`input[type='${inputType}']`);
        if (!input) return;

        // Get item text from data attribute
        const itemText = item.dataset.itemText;

        // If user clicked outside the actual input/label, we toggle/select the input
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "LABEL") {
            if (this.multipleValue) {
                // Multiple: toggle checkbox state
                input.checked = !input.checked;
            } else {
                // Single: just select the radio
                input.checked = true;
            }
        }

        if (!this.multipleValue) {
            // Close Dropdown
            this.closeDropdown()
        }

        // Handle modal display if item has text
        if (itemText && itemText.trim() !== '') {
            this.showItemModal(itemText);
        }

        this.updateSelectedObjects();
    }

    closeDropdown() {
        const dropdownElement = this.element.querySelector('[data-controller*="element--dropdown"]');

        if (dropdownElement) {
            const controllerAttr = dropdownElement.getAttribute('data-controller');
            const controllerName = controllerAttr.split(' ').find(name => name.includes('element--dropdown'));

            if (controllerName) {
                const dropdownController = this.application.getControllerForElementAndIdentifier(
                    dropdownElement,
                    controllerName
                );

                if (dropdownController) {
                    dropdownController.closeDropdown();
                }
            }
        }
    }

    showItemModal(itemText) {
        // Find the modal content element and toggle button
        const modalContent = this.modalTarget.querySelector('#dropdown-modal-wrapper-content');
        const toggleButton = this.modalTarget.querySelector('#dropdown-modal-wrapper-content-toggle');

        if (modalContent && toggleButton) {
            modalContent.textContent = itemText;
            toggleButton.click();
        }
    }

    updateSelectedObjects() {
        const inputType = this.multipleValue ? "checkbox" : "radio";
        const selectedItems = this.dropDownItemTargets.filter((item) => {
            const input = item.querySelector(`input[type='${inputType}']`);
            return input && input.checked;
        });

        if (selectedItems.length === 0) {
            this.selectedObjectsContainerTarget.innerHTML = this.placeholderValue;
            return;
        }

        const hasIcons = selectedItems.some((item) => item.innerHTML.includes("<svg"));
        const updatedString = selectedItems.map((item) => {
            return hasIcons ? item.innerHTML : item.textContent.trim();
        });

        if (hasIcons) {
            this.selectedObjectsContainerTarget.innerHTML = `<div class='flex flex-row gap-1'>${updatedString.join(', ')}</div>`;
        } else {
            this.selectedObjectsContainerTarget.innerHTML = updatedString.join(', ');
        }
    }
}
